import queryString from 'query-string';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Small workaround that checks if is `/dashboard#` (Webapp)
 * We need this as params no longer appear under `window.location.search` but under `window.location.hash` instead
 * The `#` needs removing from Webapp completely and this logic will no longer be needed.
 * @returns {boolean}
 */
var isDashboardAndHasHash = function (locHash, locHref) {
    return !!(locHash && locHash.length && locHref.includes('/dashboard'));
};
/**
 * Gets query params from the url
 * @param {string} value - url param value
 * @returns {string | null} value or null
 */
var getParameter = function (value) {
    try {
        var params = null;
        var loc = (window === null || window === void 0 ? void 0 : window.location) || { location: {} };
        var locHref = loc.href, locHash = loc.hash, locSearch = loc.search;
        if (isDashboardAndHasHash(locHash, locHref)) {
            var splitHash = locHash.split('?')[1];
            params = queryString.parse(splitHash);
        }
        else {
            params = queryString.parse(locSearch);
        }
        return params[value] || null;
    }
    catch (e) {
        return null;
    }
};

export { getParameter };
//# sourceMappingURL=index.esm.js.map
